import { database } from './';
import { Message } from '../types';

export function createMessage(userId: string, roomId: string, content: string): Promise<Message> {
    const id = database.ref('messages').push().key || '';

    const message: Message = {
        id,
        roomId,
        userId,
        content,
    };
    return database
        .ref('messages')
        .child(id)
        .set(message)
        .then(() => message);
}

export function createAdminMessage(roomId: string, content: string): Promise<Message> {
    return createMessage('admin', roomId, content);
}

export function getMessagesForRoomRef(roomId: string) {
    return database.ref('messages').orderByChild('roomId').startAt(roomId).endAt(roomId);
}
